import { Element as SvgElement } from '@svgdotjs/svg.js';
import { Region } from 'core/geometry';

export function pinSVGElement(element: SvgElement, region: Region): void
{
  element
    .size(region.width, region.height)
    .move(region.x, region.y);
}
